
import { editorStyles } from '@/components/editor/editorConfig';
import { processHtmlImages } from '@/utils/imageUtils';

interface InsightContentProps {
  content: string;
}

const InsightContent = ({ content }: InsightContentProps) => {
  // Rewrite all raw Supabase storage image URLs in the article body to go
  // through the transform API (resize + WebP conversion) before rendering.
  const optimizedContent = processHtmlImages(content, { width: 1200, quality: 80 });

  return (
    <>
      <style>{editorStyles}</style>
      {/* Public article view shares the .ProseMirror class with the editor, which
          adds horizontal padding meant only for the editor chrome. Strip it here
          so the article body uses the full width of the page container. */}
      <style>{`
        .insight-article-content.ProseMirror {
          padding-left: 0;
          padding-right: 0;
        }
      `}</style>
      <div
        className="insight-article-content prose prose-lg max-w-none prose-headings:font-bold prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl prose-p:text-gray-600 prose-a:text-primary prose-img:rounded-lg prose-pre:bg-gray-100 prose-pre:p-4 prose-ul:list-disc prose-ol:list-decimal prose-table:border-collapse prose-td:border prose-td:p-2 prose-th:border prose-th:p-2 prose-table:w-full ProseMirror"
        dangerouslySetInnerHTML={{ __html: optimizedContent }}
      />
    </>
  );
};

export default InsightContent;
